export { default as adminListHandleOnClose } from './adminListHandleOnClose';

export type {
  AdminListHandleOnCloseFunction,
  AdminListHandleOnClosePayload,
} from './adminListHandleOnClose.type';
